<template lang="pug">
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        var that = this;

        return {
            tableName: 'ATTENDANCE_SUMMARY',
            columns: ['name', 'average', 'days', 'duration', 'export'],
            options: {
                columnsClasses: {
                    export: 'text-right',
                },
                perPage: 2000,
                perPageValues: [2000],
                sortable: ['name', 'average', 'days', 'duration'],
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                texts: {
                    title: 'Staff Attendance Summary',
                    description: 'Staff attendance summary details',
                },
                pdf_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance_summary',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance_summary',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.staff_attendance.export_attendance_summary',
                    { type: 'XLSX' },
                ),
                templates: {
                    export(h, row) {
                        return require('./export-staff-summary.jsx')(
                            h,
                            row,
                            this,
                        );
                    },
                },
                headings: {
                    export: '',
                },
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        datatableUrl() {
            return Laroute.route(
                'franchise.report.staff_attendance.attendance_summary',
            );
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 2000;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/staff-attendance/staff-attendance-summary.vue